import React from 'react';
import styled from 'styled-components';
import { IconType } from 'react-icons';

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ icon, title, description }) => {
  return (
    <FeatureCardContainer>
      <IconContainer>{icon}</IconContainer>
      <FeatureTitle>{title}</FeatureTitle>
      <FeatureDescription>{description}</FeatureDescription>
    </FeatureCardContainer>
  );
};

const FeatureCardContainer = styled.div`
  background-color: var(--color-light);
  padding: 4rem 3rem;
  border-radius: 0;
  box-shadow: var(--shadow);
  transition: var(--transition);
  text-align: center;
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  }
`;

const IconContainer = styled.div`
  font-size: 4.5rem;
  color: var(--color-accent);
  margin-bottom: 2rem;
  
  svg {
    width: 1em;
    height: 1em;
  }
`;

const FeatureTitle = styled.h3`
  font-size: 2.2rem;
  margin-bottom: 1.5rem;
`;

const FeatureDescription = styled.p`
  font-size: 1.5rem;
  color: var(--color-secondary);
  margin-bottom: 0;
`;

export default FeatureCard;
